
import {IDeleteOrganisationUserPayload, IOrganisationProfilePayload, IOrganisationSettings, IOrganisationUpdateCsvPayload, IOrganisationUserUpdatePayload} from "../common/organisation";
import OrganisationRepository, {IOrganisationRepository} from "../repositories/organisation";

export class OrganisationService {
    private repository: IOrganisationRepository;
    constructor(repositoriInstance: IOrganisationRepository) {
        this.repository = repositoriInstance;
    }
    getMyOrganisation() {
        return this.repository.getMyOrganisation();
    }
    getProfiles(alias: string) {
        return this.repository.getProfiles(alias);
    }
    addProfile(profileArgs: IOrganisationProfilePayload) {
        return this.repository.addProfile(profileArgs);
    }
    deleteUser(profileArgs: IDeleteOrganisationUserPayload) {
        return this.repository.deleteUser(profileArgs);
    }
    changeOrganisationSettings(params: IOrganisationSettings) {
        return this.repository.changeOrganisationSettings(params);
    }
    updateProfile(params: IOrganisationUserUpdatePayload) {
        return this.repository.updateProfile(params);
    }
    uploadProfiles(params: IOrganisationUpdateCsvPayload) {
        return this.repository.uploadProfiles(params);
    }
}

const organisationService = new OrganisationService(new OrganisationRepository());

export default organisationService;